export enum EOpticFeature {
  Unknown = 0,
  //------SONICC---------//

  LaserPowerControl = 1,
  LaserPower = 2,
  Photosensor = 3,

  //------Visible---------//

  ContinuousZoom = 4,
  CropZoom = 5,
  Condenser = 6,
  Polarizer = 7,

  //CrossPolarizer = 8,
  Brightness = 9,

  //------UV-------------//

  ObjectiveZoom = 10,
  Illumination = 11,

  //------MFI------------//

  FilterCubes = 12,
  TotalZoom = 13,

  //------SLP------------//
  BandPassFilter = 14,
}
